import { render, staticRenderFns } from "./DisplayModify.vue?vue&type=template&id=55a7975b&scoped=true"
import script from "./DisplayModify.vue?vue&type=script&lang=ts"
export * from "./DisplayModify.vue?vue&type=script&lang=ts"
import style0 from "./DisplayModify.vue?vue&type=style&index=0&id=55a7975b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7975b",
  null
  
)

export default component.exports